



// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Box,
//   Typography,
//   Button,
//   CircularProgress,
//   DialogActions,
//   Chip,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ReassignOrderButton from "./ReassignOrderButton";

// import httpclient from "../../../../Utils";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import OrderInformation from "./OrderInformation";
// import OrderLinesTable from "./OrderLinesTable";
// import OrderAuditTrialModal from "../../../../Components/modals/OrderAuditTrialModal";
// import { getStatusColor } from "./orderUtils";

// const OrderDetailsModal = ({ open, onClose, jobId, allDrivers = [], onRefresh }) => {
//   const [orderDetails, setOrderDetails] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [auditTrailOpen, setAuditTrailOpen] = useState(false);
//   const [fileViewerOpen, setFileViewerOpen] = useState(false);
//   const [viewerFiles, setViewerFiles] = useState([]);
//   const [viewerTitle, setViewerTitle] = useState("");
//   const [selectedFileIndex, setSelectedFileIndex] = useState(0);

//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (open && jobId) {
//       fetchOrderDetails();
//     }
//   }, [open, jobId]);

//   const fetchOrderDetails = async () => {
//     setLoading(true);
//     try {
//       const { data } = await httpclient.get(`delivery/orders/details/${jobId}`);

//       if (data.status === 200) {
//         setOrderDetails(data.data);
//       } else {
//         showNotification(
//           "error",
//           data.message || "Failed to fetch order details",
//         );
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAuditTrailOpen = () => {
//     setAuditTrailOpen(true);
//   };

//   const handleAuditTrailClose = () => {
//     setAuditTrailOpen(false);
//   };

//   const handleTrackOrder = () => {
//     if (orderDetails?.job_id) {
//       navigate(`/delivery/orders/track-order?orderId=${orderDetails.job_id}`, {
//         state: { fromModal: true, jobId: orderDetails.job_id },
//       });
//       onClose();
//     }
//   };

//   const handleReassignSuccess = () => {
//     // Refresh order details after reassignment
//     fetchOrderDetails();
//     // Call parent refresh callback if provided
//     if (onRefresh && typeof onRefresh === 'function') {
//       onRefresh();
//     }
//   };

//   const formatDateTime = (value) => {
//     if (!value) return "-";

//     const parsedDate = new Date(value);
//     if (Number.isNaN(parsedDate.getTime())) {
//       return value;
//     }

//     return parsedDate.toLocaleString("en-AU", {
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     });
//   };

//   const getFilePath = (file) => {
//     if (typeof file === "string") return file;
//     return file?.file_path || "";
//   };

//   const handleOpenFileViewer = (files, title) => {
//     const validFiles = (files || []).filter((file) => Boolean(getFilePath(file)));
//     if (validFiles.length === 0) {
//       return;
//     }

//     setViewerFiles(validFiles);
//     setViewerTitle(title);
//     setSelectedFileIndex(0);
//     setFileViewerOpen(true);
//   };

//   const handleCloseFileViewer = () => {
//     setFileViewerOpen(false);
//     setViewerFiles([]);
//     setViewerTitle("");
//     setSelectedFileIndex(0);
//   };

//   const handlePrevFile = () => {
//     setSelectedFileIndex((prev) =>
//       prev === 0 ? viewerFiles.length - 1 : prev - 1,
//     );
//   };

//   const handleNextFile = () => {
//     setSelectedFileIndex((prev) =>
//       prev === viewerFiles.length - 1 ? 0 : prev + 1,
//     );
//   };

//   const deliveryStatusHistory = orderDetails?.order_delivery_status_history || [];

//   const statusColors = getStatusColor(orderDetails?.delivery_status);

//   const normalizedHeaderStatus = (orderDetails?.delivery_status || "")
//     .toString()
//     .trim()
//     .toLowerCase();
//   const normalizedHeaderMessage = (orderDetails?.order_current_status_message || "")
//     .toString()
//     .trim()
//     .toLowerCase();
//   const shouldShowStatusMessage =
//     normalizedHeaderMessage.length > 0 &&
//     normalizedHeaderMessage !== normalizedHeaderStatus;

//   const getStatusChipStyles = (statusValue) => {
//     const colors = getStatusColor(statusValue);

//     return {
//       backgroundColor: colors.bgcolor,
//       color: colors.color,
//       border: "none",
//       fontWeight: 600,
//       height: 24,
//       "& .MuiChip-label": {
//         px: 1,
//       },
//     };
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: "8px",
//             height: "90vh",
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             pb: 1,
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Job Details
//             </Typography>

//             {!loading && orderDetails && (
//               <>
//                 <Chip
//                   size="small"
//                   label={orderDetails?.delivery_status || "Unknown"}
//                   sx={{
//                     backgroundColor: statusColors.bgcolor,
//                     color: statusColors.color,
//                     fontWeight: 600,
//                     height: 24,
//                   }}
//                 />
//                 {shouldShowStatusMessage && (
//                   <Typography
//                     sx={{
//                       fontSize: "12px",
//                       fontWeight: 500,
//                       color: "#4B5563",
//                     }}
//                   >
//                     {orderDetails.order_current_status_message}
//                   </Typography>
//                 )}
//               </>
//             )}
//           </Box>
//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent
//           dividers
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             px: 2,
//             py: 1.5,
//           }}
//         >
//           {loading ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 minHeight: 300,
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           ) : orderDetails ? (
//             <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1.5 }}>
//               {orderDetails.delivery_track_button_enabled === 1 && (
//                 <Box>
//                   <Typography
//                     variant="subtitle1"
//                     sx={{ fontWeight: 600, mb: 1, color: "#383E49" }}
//                   >
//                     Delivery Status History
//                   </Typography>

//                   <TableContainer
//                     component={Paper}
//                     sx={{
//                       border: "1px solid #D7DCE3",
//                       borderRadius: "10px",
//                       boxShadow: "0 1px 2px rgba(15, 23, 42, 0.08)",
//                       overflow: "hidden",
//                       backgroundColor: "#FFFFFF",
//                     }}
//                   >
//                     <Table
//                       size="small"
//                       sx={{
//                         "& .MuiTableHead-root .MuiTableCell-root": {
//                           backgroundColor: "#F8FAFC",
//                           borderBottom: "1px solid #D7DCE3",
//                         },
//                         "& .MuiTableBody-root .MuiTableCell-root": {
//                           borderBottom: "1px solid #ECEFF3",
//                         },
//                         "& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root": {
//                           borderBottom: "none",
//                         },
//                       }}
//                     >
//                       <TableHead>
//                         <TableRow>
//                           <TableCell sx={{ fontWeight: 700, py: 1 }}>Status</TableCell>
//                           <TableCell sx={{ fontWeight: 700, py: 1 }}>Date / Time</TableCell>
//                           <TableCell sx={{ fontWeight: 700, py: 1 }}>Driver</TableCell>
//                           <TableCell sx={{ fontWeight: 700, py: 1 }}>Remarks/Reason</TableCell>
//                           <TableCell sx={{ fontWeight: 700, py: 1 }}>Signature</TableCell>
//                           <TableCell sx={{ fontWeight: 700, py: 1 }}>Other Files</TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {deliveryStatusHistory.length > 0 ? (
//                           deliveryStatusHistory.map((history, index) => {
//                             const signatureFiles = history?.signature_files || [];
//                             const otherFiles = history?.other_files || [];

//                             return (
//                               <TableRow key={`${history?.date_time || "status"}-${index}`}>
//                                 <TableCell sx={{ py: 0.75 }}>
//                                   <Chip
//                                     size="small"
//                                     label={history?.status || "-"}
//                                     sx={getStatusChipStyles(history?.status)}
//                                   />
//                                 </TableCell>
//                                 <TableCell sx={{ py: 0.75 }}>{formatDateTime(history?.date_time)}</TableCell>
//                                 <TableCell sx={{ py: 0.75 }}>{history?.driver || "-"}</TableCell>
//                                 <TableCell sx={{ py: 0.75 }}>{history?.remarks || history?.actionMessage || "-"}</TableCell>
//                                 <TableCell sx={{ py: 0.75, textAlign: "center" }}>
//                                   {signatureFiles.length > 0 ? (
//                                     <Button
//                                       size="small"
//                                       variant="outlined"
//                                       onClick={() =>
//                                         handleOpenFileViewer(signatureFiles, "Signature")
//                                       }
//                                     >
//                                       View
//                                     </Button>
//                                   ) : (
//                                     "-"
//                                   )}
//                                 </TableCell>
//                                 <TableCell sx={{ py: 0.75, textAlign: "center" }}>
//                                   {otherFiles.length > 0 ? (
//                                     <Button
//                                       size="small"
//                                       variant="outlined"
//                                       onClick={() =>
//                                         handleOpenFileViewer(otherFiles, "Other Files")
//                                       }
//                                     >
//                                       {otherFiles.length > 1 ? `View (${otherFiles.length})` : "View"}
//                                     </Button>
//                                   ) : (
//                                     "-"
//                                   )}
//                                 </TableCell>
//                               </TableRow>
//                             );
//                           })
//                         ) : (
//                           <TableRow>
//                             <TableCell colSpan={6} align="center" sx={{ py: 2 }}>
//                               No delivery status history available.
//                             </TableCell>
//                           </TableRow>
//                         )}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 </Box>
//               )}

//               <OrderInformation orderDetails={orderDetails} />

//               <OrderLinesTable jobId={jobId} />
//             </Box>
//           ) : (
//             <Typography variant="body2" color="text.secondary" align="center">
//               No order details available
//             </Typography>
//           )}
//         </DialogContent>

//         {!loading && orderDetails && (
//           <DialogActions
//             sx={{
//               px: 3,
//               pb: 2,
//               display: "flex",
//               justifyContent: "flex-end",
//               gap: 2,
//             }}
//           >
//             {/* Reassign Invoice Button - Added before View Audit Trail */}
//             {orderDetails.invoice_reassign_button_enabled === 1 && (
//               <ReassignOrderButton
//                 jobId={orderDetails.job_id}
//   currentDriverName={orderDetails.assigned_driver}
//   currentDriverId={orderDetails.driver_id} // Add this line
//   allDrivers={allDrivers}
//   onSuccess={handleReassignSuccess}
//   buttonText="Reassign Invoice"
//   variant="outlined"
//   size="medium"
//               />
//             )}

//             <Button
//               variant="outlined"
//               onClick={handleAuditTrailOpen}
//               sx={{
//                 borderColor: "#7152F3",
//                 color: "#7152F3",
//                 fontWeight: 600,
//                 px: 3,
//                 py: 1,
//                 borderRadius: "8px",
//                 textTransform: "none",
//                 fontSize: "14px",
//                 "&:hover": {
//                   borderColor: "#5c34fa",
//                   backgroundColor: "rgba(113, 82, 243, 0.08)",
//                 },
//               }}
//             >
//               View Audit Trail
//             </Button>
            
//             {/* {orderDetails.delivery_track_button_enabled === 1 && (
//               <Button
//                 variant="contained"
//                 onClick={handleTrackOrder}
//                 sx={{
//                   backgroundColor: "#7152F3",
//                   color: "#FFFFFF",
//                   fontWeight: 600,
//                   px: 3,
//                   py: 1,
//                   borderRadius: "8px",
//                   textTransform: "none",
//                   fontSize: "14px",
//                   "&:hover": {
//                     backgroundColor: "#5c34fa",
//                   },
//                 }}
//               >
//                 Track Order
//               </Button>
//             )} */}
//           </DialogActions>
//         )}
//       </Dialog>

//       {/* Audit Trail Modal */}
//       {auditTrailOpen && (
//         <OrderAuditTrialModal
//           open={auditTrailOpen}
//           handleClose={handleAuditTrailClose}
//           jobId={jobId}
//         />
//       )}

//       <Dialog
//         open={fileViewerOpen}
//         onClose={handleCloseFileViewer}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           sx: {
//             bgcolor: "rgba(0, 0, 0, 0.95)",
//             borderRadius: "12px",
//             overflow: "hidden",
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             color: "#fff",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             pb: 1,
//           }}
//         >
//           <Typography variant="subtitle1" sx={{ color: "#fff", fontWeight: 600 }}>
//             {viewerTitle}
//           </Typography>
//           <IconButton onClick={handleCloseFileViewer} size="small" sx={{ color: "#fff" }}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent
//           sx={{
//             p: 0,
//             position: "relative",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             minHeight: "420px",
//           }}
//         >
//           {viewerFiles.length > 1 && (
//             <>
//               <IconButton
//                 onClick={handlePrevFile}
//                 sx={{
//                   position: "absolute",
//                   left: 16,
//                   color: "white",
//                   bgcolor: "rgba(255, 255, 255, 0.1)",
//                   "&:hover": {
//                     bgcolor: "rgba(255, 255, 255, 0.2)",
//                   },
//                   zIndex: 1,
//                 }}
//               >
//                 <ChevronLeftIcon fontSize="large" />
//               </IconButton>

//               <IconButton
//                 onClick={handleNextFile}
//                 sx={{
//                   position: "absolute",
//                   right: 16,
//                   color: "white",
//                   bgcolor: "rgba(255, 255, 255, 0.1)",
//                   "&:hover": {
//                     bgcolor: "rgba(255, 255, 255, 0.2)",
//                   },
//                   zIndex: 1,
//                 }}
//               >
//                 <ChevronRightIcon fontSize="large" />
//               </IconButton>
//             </>
//           )}

//           <Box
//             sx={{
//               width: "100%",
//               px: 8,
//               py: 2,
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//             }}
//           >
//             {viewerFiles.length > 0 && (
//               <img
//                 src={getFilePath(viewerFiles[selectedFileIndex])}
//                 alt={viewerFiles[selectedFileIndex]?.file_name || "Delivery file"}
//                 style={{
//                   maxWidth: "100%",
//                   maxHeight: "75vh",
//                   objectFit: "contain",
//                   borderRadius: "8px",
//                 }}
//               />
//             )}
//             <Typography
//               variant="body2"
//               sx={{ color: "rgba(255, 255, 255, 0.75)", mt: 2, textAlign: "center" }}
//             >
//               {viewerFiles.length > 0
//                 ? `${viewerFiles[selectedFileIndex]?.file_name || "File"} (${selectedFileIndex + 1} of ${viewerFiles.length})`
//                 : "No file available"}
//             </Typography>
//           </Box>
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

// export default OrderDetailsModal;

// *************************************************************************************************************************************************

// import { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Box,
//   Typography,
//   Button,
//   CircularProgress,
//   DialogActions,
//   Chip,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ReassignOrderButton from "./ReassignOrderButton";

// import httpclient from "../../../../Utils";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import OrderInformation from "./OrderInformation";
// import OrderLinesTable from "./OrderLinesTable";
// import OrderAuditTrialModal from "../../../../Components/modals/OrderAuditTrialModal";
// import { getStatusColor } from "./orderUtils";

// const OrderDetailsModal = ({ open, onClose, jobId, allDrivers = [], onRefresh }) => {
//   const [orderDetails, setOrderDetails] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [auditTrailOpen, setAuditTrailOpen] = useState(false);
//   const [fileViewerOpen, setFileViewerOpen] = useState(false);
//   const [viewerFiles, setViewerFiles] = useState([]);
//   const [viewerTitle, setViewerTitle] = useState("");
//   const [selectedFileIndex, setSelectedFileIndex] = useState(0);

//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (open && jobId) {
//       fetchOrderDetails();
//     }
//   }, [open, jobId]);

//   const fetchOrderDetails = async () => {
//     setLoading(true);
//     try {
//       const { data } = await httpclient.get(`delivery/orders/details/${jobId}`);

//       if (data.status === 200) {
//         setOrderDetails(data.data);
//       } else {
//         showNotification(
//           "error",
//           data.message || "Failed to fetch order details",
//         );
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAuditTrailOpen = () => {
//     setAuditTrailOpen(true);
//   };

//   const handleAuditTrailClose = () => {
//     setAuditTrailOpen(false);
//   };

//   const handleTrackOrder = () => {
//     if (orderDetails?.job_id) {
//       navigate(`/delivery/orders/track-order?orderId=${orderDetails.job_id}`, {
//         state: { fromModal: true, jobId: orderDetails.job_id },
//       });
//       onClose();
//     }
//   };

//   const handleReassignSuccess = () => {
//     fetchOrderDetails();
//     if (onRefresh && typeof onRefresh === 'function') {
//       onRefresh();
//     }
//   };

//   const formatDateTime = (value) => {
//     if (!value) return "-";

//     const parsedDate = new Date(value);
//     if (Number.isNaN(parsedDate.getTime())) {
//       return value;
//     }

//     return parsedDate.toLocaleString("en-AU", {
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     });
//   };

//   const getFilePath = (file) => {
//     if (typeof file === "string") return file;
//     return file?.file_path || "";
//   };

//   const handleOpenFileViewer = (files, title) => {
//     const validFiles = (files || []).filter((file) => Boolean(getFilePath(file)));
//     if (validFiles.length === 0) {
//       return;
//     }

//     setViewerFiles(validFiles);
//     setViewerTitle(title);
//     setSelectedFileIndex(0);
//     setFileViewerOpen(true);
//   };

//   const handleCloseFileViewer = () => {
//     setFileViewerOpen(false);
//     setViewerFiles([]);
//     setViewerTitle("");
//     setSelectedFileIndex(0);
//   };

//   const handlePrevFile = () => {
//     setSelectedFileIndex((prev) =>
//       prev === 0 ? viewerFiles.length - 1 : prev - 1,
//     );
//   };

//   const handleNextFile = () => {
//     setSelectedFileIndex((prev) =>
//       prev === viewerFiles.length - 1 ? 0 : prev + 1,
//     );
//   };

//   const deliveryStatusHistory = orderDetails?.order_delivery_status_history || [];

//   const statusColors = getStatusColor(orderDetails?.delivery_status);

//   const normalizedHeaderStatus = (orderDetails?.delivery_status || "")
//     .toString()
//     .trim()
//     .toLowerCase();
//   const normalizedHeaderMessage = (orderDetails?.order_current_status_message || "")
//     .toString()
//     .trim()
//     .toLowerCase();
//   const shouldShowStatusMessage =
//     normalizedHeaderMessage.length > 0 &&
//     normalizedHeaderMessage !== normalizedHeaderStatus;

//   const getStatusChipStyles = (statusValue) => {
//     const colors = getStatusColor(statusValue);

//     return {
//       backgroundColor: colors.bgcolor,
//       color: colors.color,
//       border: "none",
//       fontWeight: 600,
//       height: 24,
//       "& .MuiChip-label": {
//         px: 1,
//       },
//     };
//   };

//   // Calculate if we need scrolling (more than 4 items)
//   // Each row is approximately 48px (40px height + 8px padding)
//   // Header is approximately 48px
//   // 4 rows = ~192px + header ~48px = ~240px
//   const needsScrolling = deliveryStatusHistory.length > 4;

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: "8px",
//             height: "90vh",
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             pb: 1,
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Job Details
//             </Typography>

//             {!loading && orderDetails && (
//               <>
//                 <Chip
//                   size="small"
//                   label={orderDetails?.delivery_status || "Unknown"}
//                   sx={{
//                     backgroundColor: statusColors.bgcolor,
//                     color: statusColors.color,
//                     fontWeight: 600,
//                     height: 24,
//                   }}
//                 />
//                 {shouldShowStatusMessage && (
//                   <Typography
//                     sx={{
//                       fontSize: "12px",
//                       fontWeight: 500,
//                       color: "#4B5563",
//                     }}
//                   >
//                     {orderDetails.order_current_status_message}
//                   </Typography>
//                 )}
//               </>
//             )}
//           </Box>
//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent
//           dividers
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             px: 2,
//             py: 1.5,
//             overflow: "auto",
//           }}
//         >
//           {loading ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 minHeight: 300,
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           ) : orderDetails ? (
//             <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1.5 }}>
//               {orderDetails.delivery_track_button_enabled === 1 && (
//                 <Box>
//                   <Typography
//                     variant="subtitle1"
//                     sx={{ fontWeight: 600, mb: 1, color: "#383E49" }}
//                   >
//                     Delivery Status History
//                   </Typography>

//                   <TableContainer
//                     component={Paper}
//                     sx={{
//                       border: "1px solid #D7DCE3",
//                       borderRadius: "10px",
//                       boxShadow: "0 1px 2px rgba(15, 23, 42, 0.08)",
//                       backgroundColor: "#FFFFFF",
//                       width: "100%",
//                       // Show 4 rows (approx 240px) and scroll for more
//                       maxHeight: needsScrolling ? "260px" : "auto",
//                       overflowY: needsScrolling ? "auto" : "visible",
//                       overflowX: "auto",
//                       // Critical: Ensure the container respects maxHeight
//                       display: "block",
//                       // Add a subtle scrollbar indicator
//                       '&::-webkit-scrollbar': {
//                         width: '6px',
//                         height: '6px',
//                       },
//                       '&::-webkit-scrollbar-track': {
//                         background: '#f1f1f1',
//                         borderRadius: '3px',
//                       },
//                       '&::-webkit-scrollbar-thumb': {
//                         background: '#c1c1c1',
//                         borderRadius: '3px',
//                       },
//                       '&::-webkit-scrollbar-thumb:hover': {
//                         background: '#a8a8a8',
//                       },
//                     }}
//                   >
//                     <Table
//                       size="small"
//                       sx={{
//                         minWidth: 650,
//                         "& .MuiTableHead-root .MuiTableCell-root": {
//                           backgroundColor: "#F8FAFC",
//                           borderBottom: "1px solid #D7DCE3",
//                           position: "sticky",
//                           top: 0,
//                           zIndex: 1,
//                           boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
//                         },
//                         "& .MuiTableBody-root .MuiTableCell-root": {
//                           borderBottom: "1px solid #ECEFF3",
//                           paddingTop: "8px",
//                           paddingBottom: "8px",
//                         },
//                         "& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root": {
//                           borderBottom: "none",
//                         },
//                       }}
//                     >
//                       <TableHead>
//                         <TableRow>
//                           <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 100 }}>Status</TableCell>
//                           <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 140 }}>Date / Time</TableCell>
//                           <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 120 }}>Driver</TableCell>
//                           <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 140 }}>Remarks/Reason</TableCell>
//                           <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 120, textAlign: "center" }}>Signature</TableCell>
//                           <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 120, textAlign: "center" }}>Other Files</TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {deliveryStatusHistory.length > 0 ? (
//                           deliveryStatusHistory.map((history, index) => {
//                             const signatureFiles = history?.signature_files || [];
//                             const otherFiles = history?.other_files || [];

//                             return (
//                               <TableRow key={`${history?.date_time || "status"}-${index}`}>
//                                 <TableCell sx={{ py: 0.75 }}>
//                                   <Chip
//                                     size="small"
//                                     label={history?.status || "-"}
//                                     sx={getStatusChipStyles(history?.status)}
//                                   />
//                                 </TableCell>
//                                 <TableCell sx={{ py: 0.75 }}>{formatDateTime(history?.date_time)}</TableCell>
//                                 <TableCell sx={{ py: 0.75 }}>{history?.driver || "-"}</TableCell>
//                                 <TableCell sx={{ py: 0.75 }}>{history?.remarks || history?.actionMessage || "-"}</TableCell>
//                                 <TableCell sx={{ py: 0.75, textAlign: "center" }}>
//                                   {signatureFiles.length > 0 ? (
//                                     <Button
//                                       size="small"
//                                       variant="outlined"
//                                       onClick={() =>
//                                         handleOpenFileViewer(signatureFiles, "Signature")
//                                       }
//                                     >
//                                       View
//                                     </Button>
//                                   ) : (
//                                     "-"
//                                   )}
//                                 </TableCell>
//                                 <TableCell sx={{ py: 0.75, textAlign: "center" }}>
//                                   {otherFiles.length > 0 ? (
//                                     <Button
//                                       size="small"
//                                       variant="outlined"
//                                       onClick={() =>
//                                         handleOpenFileViewer(otherFiles, "Other Files")
//                                       }
//                                     >
//                                       {otherFiles.length > 1 ? `View (${otherFiles.length})` : "View"}
//                                     </Button>
//                                   ) : (
//                                     "-"
//                                   )}
//                                 </TableCell>
//                               </TableRow>
//                             );
//                           })
//                         ) : (
//                           <TableRow>
//                             <TableCell colSpan={6} align="center" sx={{ py: 2 }}>
//                               No delivery status history available.
//                             </TableCell>
//                           </TableRow>
//                         )}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 </Box>
//               )}

//               <OrderInformation orderDetails={orderDetails} />

//               <OrderLinesTable jobId={jobId} />
//             </Box>
//           ) : (
//             <Typography variant="body2" color="text.secondary" align="center">
//               No order details available
//             </Typography>
//           )}
//         </DialogContent>

//         {!loading && orderDetails && (
//           <DialogActions
//             sx={{
//               px: 3,
//               pb: 2,
//               display: "flex",
//               justifyContent: "flex-end",
//               gap: 2,
//             }}
//           >
//             {orderDetails.invoice_reassign_button_enabled === 1 && (
//               <ReassignOrderButton
//                 jobId={orderDetails.job_id}
//                 currentDriverName={orderDetails.assigned_driver}
//                 currentDriverId={orderDetails.driver_id}
//                 allDrivers={allDrivers}
//                 onSuccess={handleReassignSuccess}
//                 buttonText="Reassign Invoice"
//                 variant="outlined"
//                 size="medium"
//               />
//             )}

//             <Button
//               variant="outlined"
//               onClick={handleAuditTrailOpen}
//               sx={{
//                 borderColor: "#7152F3",
//                 color: "#7152F3",
//                 fontWeight: 600,
//                 px: 3,
//                 py: 1,
//                 borderRadius: "8px",
//                 textTransform: "none",
//                 fontSize: "14px",
//                 "&:hover": {
//                   borderColor: "#5c34fa",
//                   backgroundColor: "rgba(113, 82, 243, 0.08)",
//                 },
//               }}
//             >
//               View Audit Trail
//             </Button>
//           </DialogActions>
//         )}
//       </Dialog>

//       {/* Audit Trail Modal */}
//       {auditTrailOpen && (
//         <OrderAuditTrialModal
//           open={auditTrailOpen}
//           handleClose={handleAuditTrailClose}
//           jobId={jobId}
//         />
//       )}

//       <Dialog
//         open={fileViewerOpen}
//         onClose={handleCloseFileViewer}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           sx: {
//             bgcolor: "rgba(0, 0, 0, 0.95)",
//             borderRadius: "12px",
//             overflow: "hidden",
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             color: "#fff",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             pb: 1,
//           }}
//         >
//           <Typography variant="subtitle1" sx={{ color: "#fff", fontWeight: 600 }}>
//             {viewerTitle}
//           </Typography>
//           <IconButton onClick={handleCloseFileViewer} size="small" sx={{ color: "#fff" }}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent
//           sx={{
//             p: 0,
//             position: "relative",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             minHeight: "420px",
//           }}
//         >
//           {viewerFiles.length > 1 && (
//             <>
//               <IconButton
//                 onClick={handlePrevFile}
//                 sx={{
//                   position: "absolute",
//                   left: 16,
//                   color: "white",
//                   bgcolor: "rgba(255, 255, 255, 0.1)",
//                   "&:hover": {
//                     bgcolor: "rgba(255, 255, 255, 0.2)",
//                   },
//                   zIndex: 1,
//                 }}
//               >
//                 <ChevronLeftIcon fontSize="large" />
//               </IconButton>

//               <IconButton
//                 onClick={handleNextFile}
//                 sx={{
//                   position: "absolute",
//                   right: 16,
//                   color: "white",
//                   bgcolor: "rgba(255, 255, 255, 0.1)",
//                   "&:hover": {
//                     bgcolor: "rgba(255, 255, 255, 0.2)",
//                   },
//                   zIndex: 1,
//                 }}
//               >
//                 <ChevronRightIcon fontSize="large" />
//               </IconButton>
//             </>
//           )}

//           <Box
//             sx={{
//               width: "100%",
//               px: 8,
//               py: 2,
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//             }}
//           >
//             {viewerFiles.length > 0 && (
//               <img
//                 src={getFilePath(viewerFiles[selectedFileIndex])}
//                 alt={viewerFiles[selectedFileIndex]?.file_name || "Delivery file"}
//                 style={{
//                   maxWidth: "100%",
//                   maxHeight: "75vh",
//                   objectFit: "contain",
//                   borderRadius: "8px",
//                 }}
//               />
//             )}
//             <Typography
//               variant="body2"
//               sx={{ color: "rgba(255, 255, 255, 0.75)", mt: 2, textAlign: "center" }}
//             >
//               {viewerFiles.length > 0
//                 ? `${viewerFiles[selectedFileIndex]?.file_name || "File"} (${selectedFileIndex + 1} of ${viewerFiles.length})`
//                 : "No file available"}
//             </Typography>
//           </Box>
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

// export default OrderDetailsModal;
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Box,
//   Typography,
//   Button,
//   CircularProgress,
//   DialogActions,
//   Chip,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Tooltip,
//   Tab,
//   Tabs,
//   Divider,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ReassignOrderButton from "./ReassignOrderButton";

// import httpclient from "../../../../Utils";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import OrderInformation from "./OrderInformation";
// import OrderLinesTable from "./OrderLinesTable";
// import OrderAuditTrialModal from "../../../../Components/modals/OrderAuditTrialModal";
// import { getStatusColor } from "./orderUtils";

// // Custom color mapping for statuses
// // const getStatusColor = (status) => {
// //   const statusMap = {
// //     'All': { bgcolor: '#9E9E9E', color: '#FFFFFF' },
// //     'Waiting for Delivery': { bgcolor: '#9E9E9E', color: '#FFFFFF' },
// //     'Waiting For Delivery': { bgcolor: '#9E9E9E', color: '#FFFFFF' },
// //     'In Queue': { bgcolor: '#1E3A8A', color: '#FFFFFF' },
// //     'In Progress': { bgcolor: '#2196F3', color: '#FFFFFF' },
// //     'Inprogress': { bgcolor: '#2196F3', color: '#FFFFFF' },
// //     'Paused': { bgcolor: '#FF9800', color: '#FFFFFF' },
// //     'Loaded': { bgcolor: '#00BCD4', color: '#FFFFFF' },
// //     'In Transit': { bgcolor: '#3F51B5', color: '#FFFFFF' },
// //     'InTransit': { bgcolor: '#3F51B5', color: '#FFFFFF' },
// //     'Drop To Depot': { bgcolor: '#04384d', color: '#FFFFFF' },
// //     'Drop to Depot': { bgcolor: '#04384d', color: '#FFFFFF' },
// //     'Delivered': { bgcolor: '#4CAF50', color: '#FFFFFF' },
// //     'Unloaded': { bgcolor: '#9C27B0', color: '#FFFFFF' },
// //     'Canceled': { bgcolor: '#F44336', color: '#FFFFFF' },
// //     'Cancelled': { bgcolor: '#F44336', color: '#FFFFFF' },
// //   };

// //   const normalizedStatus = status?.toString().trim() || '';
  
// //   if (statusMap[normalizedStatus]) {
// //     return statusMap[normalizedStatus];
// //   }
  
// //   const lowerStatus = normalizedStatus.toLowerCase();
// //   for (const [key, value] of Object.entries(statusMap)) {
// //     if (key.toLowerCase() === lowerStatus) {
// //       return value;
// //     }
// //   }
  
// //   if (lowerStatus.includes('waiting') || lowerStatus.includes('pending')) {
// //     return statusMap['Waiting for Delivery'];
// //   }
// //   if (lowerStatus.includes('queue')) {
// //     return statusMap['In Queue'];
// //   }
// //   if (lowerStatus.includes('progress')) {
// //     return statusMap['In Progress'];
// //   }
// //   if (lowerStatus.includes('paus')) {
// //     return statusMap['Paused'];
// //   }
// //   if (lowerStatus.includes('load')) {
// //     return statusMap['Loaded'];
// //   }
// //   if (lowerStatus.includes('transit')) {
// //     return statusMap['In Transit'];
// //   }
// //   if (lowerStatus.includes('depot')) {
// //     return statusMap['Drop To Depot'];
// //   }
// //   if (lowerStatus.includes('deliver')) {
// //     return statusMap['Delivered'];
// //   }
// //   if (lowerStatus.includes('unload')) {
// //     return statusMap['Unloaded'];
// //   }
// //   if (lowerStatus.includes('cancel')) {
// //     return statusMap['Canceled'];
// //   }
  
// //   return { bgcolor: '#9E9E9E', color: '#FFFFFF' };
// // };

// // Map status for display
// const mapStatus = (status) => {
//   const statusMap = {
//     'inQueue': 'In Queue',
//     'inProgress': 'In Progress',
//     'inprogress': 'In Progress',
//     'paused': 'Paused',
//     'loaded': 'Loaded',
//     'inTransit': 'In Transit',
//     'dropToDepot': 'Drop To Depot',
//     'drop to depot': 'Drop To Depot',
//     'delivered': 'Delivered',
//     'unloaded': 'Unloaded',
//     'canceled': 'Canceled',
//     'cancelled': 'Canceled',
//   };
  
//   const normalizedStatus = status?.toString().toLowerCase().trim() || '';
//   return statusMap[normalizedStatus] || status || 'Unknown';
// };

// // Status History Table Component
// const StatusHistoryTable = ({ history, getStatusChipStyles, formatDateTime, handleOpenFileViewer }) => {
//   return (
//     <TableContainer
//       component={Paper}
//       sx={{
//         border: "1px solid #D7DCE3",
//         borderRadius: "10px",
//         boxShadow: "0 1px 2px rgba(15, 23, 42, 0.08)",
//         backgroundColor: "#FFFFFF",
//         width: "100%",
//         maxHeight: history?.length > 4 ? "260px" : "auto",
//         overflowY: history?.length > 4 ? "auto" : "visible",
//         overflowX: "auto",
//         display: "block",
//         '&::-webkit-scrollbar': {
//           width: '6px',
//           height: '6px',
//         },
//         '&::-webkit-scrollbar-track': {
//           background: '#f1f1f1',
//           borderRadius: '3px',
//         },
//         '&::-webkit-scrollbar-thumb': {
//           background: '#c1c1c1',
//           borderRadius: '3px',
//         },
//         '&::-webkit-scrollbar-thumb:hover': {
//           background: '#a8a8a8',
//         },
//       }}
//     >
//       <Table
//         size="small"
//         sx={{
//           minWidth: 650,
//           "& .MuiTableHead-root .MuiTableCell-root": {
//             backgroundColor: "#F8FAFC",
//             borderBottom: "1px solid #D7DCE3",
//             position: "sticky",
//             top: 0,
//             zIndex: 1,
//             boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
//           },
//           "& .MuiTableBody-root .MuiTableCell-root": {
//             borderBottom: "1px solid #ECEFF3",
//             paddingTop: "8px",
//             paddingBottom: "8px",
//           },
//           "& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root": {
//             borderBottom: "none",
//           },
//         }}
//       >
//         <TableHead>
//           <TableRow>
//             <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 100 }}>Status</TableCell>
//             <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 140 }}>Date / Time</TableCell>
//             <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 120 }}>Driver</TableCell>
//             <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 140 }}>Remarks/Reason</TableCell>
//             <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 120, textAlign: "center" }}>Signature</TableCell>
//             <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 120, textAlign: "center" }}>Other Files</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {history && history.length > 0 ? (
//             history.map((item, index) => {
//               const signatureFiles = item?.signature_files || [];
//               const otherFiles = item?.other_files || [];
//               const statusDisplay = mapStatus(item?.status);

//               return (
//                 <TableRow key={`${item?.date_time || "status"}-${index}`}>
//                   <TableCell sx={{ py: 0.75 }}>
//                     <Chip
//                       size="small"
//                       label={statusDisplay || "-"}
//                       sx={getStatusChipStyles(item?.status)}
//                     />
//                   </TableCell>
//                   <TableCell sx={{ py: 0.75 }}>{formatDateTime(item?.date_time)}</TableCell>
//                   <TableCell sx={{ py: 0.75 }}>{item?.driver || "-"}</TableCell>
//                   <TableCell sx={{ py: 0.75 }}>{item?.remarks || item?.actionMessage || "-"}</TableCell>
//                   <TableCell sx={{ py: 0.75, textAlign: "center" }}>
//                     {signatureFiles.length > 0 ? (
//                       <Button
//                         size="small"
//                         variant="outlined"
//                         onClick={() => handleOpenFileViewer(signatureFiles, "Signature")}
//                         sx={{
//                           textTransform: "none",
//                           fontSize: "12px",
//                           borderColor: "#D1D5DB",
//                           color: "#374151",
//                           padding: '2px 10px',
//                           '&:hover': {
//                             borderColor: "#7152F3",
//                             color: "#7152F3",
//                             backgroundColor: "rgba(113, 82, 243, 0.04)",
//                           },
//                         }}
//                       >
//                         View
//                       </Button>
//                     ) : (
//                       "-"
//                     )}
//                   </TableCell>
//                   <TableCell sx={{ py: 0.75, textAlign: "center" }}>
//                     {otherFiles.length > 0 ? (
//                       <Button
//                         size="small"
//                         variant="outlined"
//                         onClick={() => handleOpenFileViewer(otherFiles, "Other Files")}
//                         sx={{
//                           textTransform: "none",
//                           fontSize: "12px",
//                           borderColor: "#D1D5DB",
//                           color: "#374151",
//                           padding: '2px 10px',
//                           '&:hover': {
//                             borderColor: "#7152F3",
//                             color: "#7152F3",
//                             backgroundColor: "rgba(113, 82, 243, 0.04)",
//                           },
//                         }}
//                       >
//                         {otherFiles.length > 1 ? `View (${otherFiles.length})` : "View"}
//                       </Button>
//                     ) : (
//                       "-"
//                     )}
//                   </TableCell>
//                 </TableRow>
//               );
//             })
//           ) : (
//             <TableRow>
//               <TableCell colSpan={6} align="center" sx={{ py: 2 }}>
//                 No delivery status history available.
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

// // Invoice Summary Table
// const InvoiceSummaryTable = ({ invoices, onInvoiceClick, selectedInvoice }) => {
//   return (
//     <TableContainer
//       component={Paper}
//       sx={{
//         border: "1px solid #D7DCE3",
//         borderRadius: "8px",
//         boxShadow: "none",
//         overflow: "hidden",
//         backgroundColor: "#FFFFFF",
//         mb: 2,
//       }}
//     >
//       <Table size="small">
//         <TableHead sx={{ backgroundColor: "#F9FAFB" }}>
//           <TableRow>
//             <TableCell sx={{ fontWeight: 700, py: 1.5, color: "#6B7280", fontSize: "12px" }}>
//               Invoice No
//             </TableCell>
//             <TableCell sx={{ fontWeight: 700, py: 1.5, color: "#6B7280", fontSize: "12px" }}>
//               Driver
//             </TableCell>
//             <TableCell sx={{ fontWeight: 700, py: 1.5, color: "#6B7280", fontSize: "12px" }}>
//               Invoice Date
//             </TableCell>
//             <TableCell sx={{ fontWeight: 700, py: 1.5, color: "#6B7280", fontSize: "12px" }}>
//               Delivery Date
//             </TableCell>
//             <TableCell sx={{ fontWeight: 700, py: 1.5, color: "#6B7280", fontSize: "12px" }}>
//               Order Date
//             </TableCell>
//             <TableCell sx={{ fontWeight: 700, py: 1.5, color: "#6B7280", fontSize: "12px" }}>
//               Status
//             </TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {invoices.map((invoice, index) => (
//             <TableRow 
//               key={invoice.invoice_number || index}
//               hover
//               onClick={() => onInvoiceClick(invoice.invoice_number)}
//               sx={{ 
//                 cursor: 'pointer',
//                 backgroundColor: selectedInvoice === invoice.invoice_number ? '#F3F4F6' : 'transparent',
//                 '&:hover': {
//                   backgroundColor: '#F9FAFB',
//                 }
//               }}
//             >
//               <TableCell sx={{ fontWeight: 500, color: "#111827", fontSize: "13px" }}>
//                 {invoice.invoice_number}
//               </TableCell>
//               <TableCell sx={{ color: "#111827", fontSize: "13px" }}>
//                 {invoice.assigned_driver || "-"}
//               </TableCell>
//               <TableCell sx={{ color: "#111827", fontSize: "13px" }}>
//                 {invoice.invoice_date || "-"}
//               </TableCell>
//               <TableCell sx={{ color: "#111827", fontSize: "13px" }}>
//                 {invoice.delivery_date || "-"}
//               </TableCell>
//               <TableCell sx={{ color: "#111827", fontSize: "13px" }}>
//                 {invoice.order_date || "-"}
//               </TableCell>
//               <TableCell>
//                 <Chip
//                   size="small"
//                   label={mapStatus(invoice.delivery_status) || "Unknown"}
//                   sx={{
//                     backgroundColor: getStatusColor(invoice.delivery_status).bgcolor,
//                     color: getStatusColor(invoice.delivery_status).color,
//                     fontWeight: 600,
//                     height: 24,
//                     fontSize: "11px",
//                   }}
//                 />
//               </TableCell>
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

// // Main OrderDetailsModal Component
// const OrderDetailsModal = ({ 
//   open, 
//   onClose, 
//   invoiceNumbers,
//   jobId,
//   allDrivers = [], 
//   onRefresh 
// }) => {
//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [auditTrailOpen, setAuditTrailOpen] = useState(false);
//   const [fileViewerOpen, setFileViewerOpen] = useState(false);
//   const [viewerFiles, setViewerFiles] = useState([]);
//   const [viewerTitle, setViewerTitle] = useState("");
//   const [selectedFileIndex, setSelectedFileIndex] = useState(0);
//   const [expandedInvoice, setExpandedInvoice] = useState(null);
//   const [selectedTab, setSelectedTab] = useState(0);

//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();
//   const navigate = useNavigate();

//   useEffect(() => {
//     // console.log("🔍 OrderDetailsModal useEffect");
//     // console.log(" open:", open);
//     // console.log("📋 invoiceNumbers:", invoiceNumbers);
//     // console.log("📋 jobId:", jobId);
    
//     if (open && invoiceNumbers) {
//       fetchInvoiceDetails();
//     }
//   }, [open, invoiceNumbers]);

//   const fetchInvoiceDetails = async () => {
//     setLoading(true);
//     try {
//       let invoiceParam = invoiceNumbers;
//       if (Array.isArray(invoiceNumbers)) {
//         invoiceParam = invoiceNumbers.join(',');
//       }
      
//       const apiUrl = `delivery/orders/invoice/job-details?invoice_numbers=${invoiceParam}`;
//       console.log("📡 Calling API:", apiUrl);
      
//       const { data } = await httpclient.get(apiUrl);
//       console.log(" API Response:", data);

//       if (data.status === 200) {
//         setInvoices(data.data);
//         // Set first invoice as expanded by default
//         if (data.data.length > 0) {
//           setExpandedInvoice(data.data[0].invoice_number);
//         }
//       } else {
//         showNotification("error", data.message || "Failed to fetch invoice details");
//       }
//     } catch (error) {
//       console.error(" API Error:", error);
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAuditTrailOpen = () => {
//     setAuditTrailOpen(true);
//   };

//   const handleAuditTrailClose = () => {
//     setAuditTrailOpen(false);
//   };

//   const handleReassignSuccess = () => {
//     fetchInvoiceDetails();
//     if (onRefresh && typeof onRefresh === 'function') {
//       onRefresh();
//     }
//   };

//   const formatDateTime = (value) => {
//     if (!value) return "-";
//     const parsedDate = new Date(value);
//     if (Number.isNaN(parsedDate.getTime())) {
//       return value;
//     }
//     return parsedDate.toLocaleString("en-AU", {
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     });
//   };

//   const getFilePath = (file) => {
//     if (typeof file === "string") return file;
//     return file?.file_path || "";
//   };

//   const handleOpenFileViewer = (files, title) => {
//     const validFiles = (files || []).filter((file) => Boolean(getFilePath(file)));
//     if (validFiles.length === 0) {
//       return;
//     }
//     setViewerFiles(validFiles);
//     setViewerTitle(title);
//     setSelectedFileIndex(0);
//     setFileViewerOpen(true);
//   };

//   const handleCloseFileViewer = () => {
//     setFileViewerOpen(false);
//     setViewerFiles([]);
//     setViewerTitle("");
//     setSelectedFileIndex(0);
//   };

//   const handlePrevFile = () => {
//     setSelectedFileIndex((prev) =>
//       prev === 0 ? viewerFiles.length - 1 : prev - 1
//     );
//   };

//   const handleNextFile = () => {
//     setSelectedFileIndex((prev) =>
//       prev === viewerFiles.length - 1 ? 0 : prev + 1
//     );
//   };

//   const getStatusChipStyles = (statusValue) => {
//     const colors = getStatusColor(statusValue);
//     return {
//       backgroundColor: colors.bgcolor,
//       color: colors.color,
//       border: "none",
//       fontWeight: 600,
//       height: 24,
//       "& .MuiChip-label": {
//         px: 1,
//       },
//     };
//   };

//   const handleAccordionChange = (invoiceNumber) => (event, isExpanded) => {
//     setExpandedInvoice(isExpanded ? invoiceNumber : null);
//   };

//   const handleTabChange = (event, newValue) => {
//     setSelectedTab(newValue);
//     if (invoices[newValue]) {
//       setExpandedInvoice(invoices[newValue].invoice_number);
//     }
//   };

//   const getCurrentInvoice = () => {
//     if (invoices.length === 0) return null;
//     return invoices[selectedTab] || null;
//   };

//   const currentInvoice = getCurrentInvoice();

//   if (!invoiceNumbers) {
//     return (
//       <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
//         <DialogTitle>
//           <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//             <Typography variant="h6">Job Details</Typography>
//             <IconButton onClick={onClose} size="small">
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 4 }}>
//             No invoice numbers provided. Please check the parent component.
//           </Typography>
//         </DialogContent>
//       </Dialog>
//     );
//   }

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: "8px",
//             height: "90vh",
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             pb: 1,
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Job Details
//             </Typography>
//             {!loading && invoices.length > 0 && (
//               <Chip
//                 size="small"
//                 label={`${invoices.length} Invoice${invoices.length > 1 ? 's' : ''}`}
//                 sx={{
//                   backgroundColor: "#E5E7EB",
//                   color: "#374151",
//                   fontWeight: 600,
//                   height: 24,
//                 }}
//               />
//             )}
//           </Box>
//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent
//           dividers
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             px: 2,
//             py: 1.5,
//             gap: 2,
//             overflow: "auto",
//           }}
//         >
//           {loading ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 minHeight: 300,
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           ) : invoices.length > 0 ? (
//             <>
//               {/* 1. Delivery Status History */}
//               <Box>
                

//                 <Tabs
//                   value={selectedTab}
//                   onChange={handleTabChange}
//                   variant="scrollable"
//                   scrollButtons="auto"
//                   sx={{
//                     borderBottom: 1,
//                     borderColor: 'divider',
//                     mb: 2,
//                     '& .MuiTab-root': {
//                       textTransform: 'none',
//                       fontWeight: 600,
//                       fontSize: '14px',
//                       minHeight: 40,
//                     },
//                     '& .Mui-selected': {
//                       color: '#7152F3',
//                     },
//                     '& .MuiTabs-indicator': {
//                       backgroundColor: '#7152F3',
//                     },
//                   }}
//                 >
//                   {invoices.map((invoice, index) => (
//                     <Tab 
//                       key={invoice.invoice_number || index} 
//                       label={
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <span>{invoice.invoice_number}</span>
//                           <Chip
//                             size="small"
//                             label={mapStatus(invoice.delivery_status) || "Unknown"}
//                             sx={{
//                               backgroundColor: getStatusColor(invoice.delivery_status).bgcolor,
//                               color: getStatusColor(invoice.delivery_status).color,
//                               fontWeight: 600,
//                               height: 20,
//                               fontSize: "10px",
//                             }}
//                           />
//                         </Box>
//                       }
//                     />
//                   ))}
//                 </Tabs>

//                 {currentInvoice && (
//                   <Accordion
//                     expanded={expandedInvoice === currentInvoice.invoice_number}
//                     onChange={handleAccordionChange(currentInvoice.invoice_number)}
//                     sx={{
//                       border: "1px solid #E5E7EB",
//                       borderRadius: "8px !important",
//                       boxShadow: "none",
//                       mb: 2,
//                       '&:before': {
//                         display: 'none',
//                       },
//                     }}
//                   >
//                     <AccordionSummary
//                       expandIcon={<ExpandMoreIcon />}
//                       sx={{
//                         backgroundColor: "#FAFAFA",
//                         borderRadius: "8px",
//                         '&.Mui-expanded': {
//                           borderRadius: "8px 8px 0 0",
//                         },
//                       }}
//                     >
//                       <Typography sx={{ fontWeight: 600 }}>
//                         Status History
//                       </Typography>
//                     </AccordionSummary>
//                     <AccordionDetails sx={{ p: 2 }}>
//                       <StatusHistoryTable
//                         history={currentInvoice.order_delivery_status_history}
//                         getStatusChipStyles={getStatusChipStyles}
//                         formatDateTime={formatDateTime}
//                         handleOpenFileViewer={handleOpenFileViewer}
//                       />
//                     </AccordionDetails>
//                   </Accordion>
//                 )}
//               </Box>

//               {/* 2. Invoice Summary */}
//               <Box>
//                 <Typography
//                   variant="subtitle1"
//                   sx={{ fontWeight: 600, mb: 1.5, color: "#383E49" }}
//                 >
//                   Invoice Summary
//                 </Typography>
//                 <InvoiceSummaryTable 
//                   invoices={invoices} 
//                   onInvoiceClick={(invoiceNumber) => {
//                     const index = invoices.findIndex(inv => inv.invoice_number === invoiceNumber);
//                     if (index !== -1) {
//                       setSelectedTab(index);
//                       if (invoices[index]) {
//                         setExpandedInvoice(invoices[index].invoice_number);
//                       }
//                     }
//                   }}
//                   selectedInvoice={invoices[selectedTab]?.invoice_number}
//                 />
//               </Box>

//               {/* 3. Order Information (includes Customer Details) */}
//               {/* {currentInvoice && (
//                 <Box>
//                   <OrderInformation orderDetails={currentInvoice} />
//                 </Box>
//               )} */}

//               {/* 4. Order Lines Table - Using the imported component */}
//               {currentInvoice && (
//                 <Box sx={{ mb: 2 }}>
                 
                 
//                   {/* ✅ Using the imported OrderLinesTable component */}
//                   <OrderLinesTable jobId={currentInvoice.job_id} />
//                 </Box>
//               )}
//             </>
//           ) : (
//             <Typography variant="body2" color="text.secondary" align="center">
//               No invoice details available
//             </Typography>
//           )}
//         </DialogContent>

//         {!loading && invoices.length > 0 && (
//           <DialogActions
//             sx={{
//               px: 3,
//               pb: 2,
//               display: "flex",
//               justifyContent: "flex-end",
//               gap: 2,
//             }}
//           >
//             {currentInvoice?.invoice_reassign_button_enabled === 1 && (
//               <ReassignOrderButton
//                 jobId={currentInvoice?.job_id}
//                 currentDriverName={currentInvoice?.assigned_driver}
//                 currentDriverId={currentInvoice?.driver_id}
//                 allDrivers={allDrivers}
//                 onSuccess={handleReassignSuccess}
//                 buttonText="Reassign Invoice"
//                 variant="outlined"
//                 size="medium"
//               />
//             )}

//             <Button
//               variant="outlined"
//               onClick={handleAuditTrailOpen}
//               sx={{
//                 borderColor: "#7152F3",
//                 color: "#7152F3",
//                 fontWeight: 600,
//                 px: 3,
//                 py: 1,
//                 borderRadius: "8px",
//                 textTransform: "none",
//                 fontSize: "14px",
//                 "&:hover": {
//                   borderColor: "#5c34fa",
//                   backgroundColor: "rgba(113, 82, 243, 0.08)",
//                 },
//               }}
//             >
//               View Audit Trail
//             </Button>
//           </DialogActions>
//         )}
//       </Dialog>

//       {/* Audit Trail Modal */}
//       {auditTrailOpen && (
//         <OrderAuditTrialModal
//           open={auditTrailOpen}
//           handleClose={handleAuditTrailClose}
//           jobId={currentInvoice?.job_id}
//         />
//       )}

//       {/* File Viewer Dialog */}
//       <Dialog
//         open={fileViewerOpen}
//         onClose={handleCloseFileViewer}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           sx: {
//             bgcolor: "rgba(0, 0, 0, 0.95)",
//             borderRadius: "12px",
//             overflow: "hidden",
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             color: "#fff",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             pb: 1,
//           }}
//         >
//           <Typography variant="subtitle1" sx={{ color: "#fff", fontWeight: 600 }}>
//             {viewerTitle}
//           </Typography>
//           <IconButton onClick={handleCloseFileViewer} size="small" sx={{ color: "#fff" }}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent
//           sx={{
//             p: 0,
//             position: "relative",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             minHeight: "420px",
//           }}
//         >
//           {viewerFiles.length > 1 && (
//             <>
//               <IconButton
//                 onClick={handlePrevFile}
//                 sx={{
//                   position: "absolute",
//                   left: 16,
//                   color: "white",
//                   bgcolor: "rgba(255, 255, 255, 0.1)",
//                   "&:hover": {
//                     bgcolor: "rgba(255, 255, 255, 0.2)",
//                   },
//                   zIndex: 1,
//                 }}
//               >
//                 <ChevronLeftIcon fontSize="large" />
//               </IconButton>

//               <IconButton
//                 onClick={handleNextFile}
//                 sx={{
//                   position: "absolute",
//                   right: 16,
//                   color: "white",
//                   bgcolor: "rgba(255, 255, 255, 0.1)",
//                   "&:hover": {
//                     bgcolor: "rgba(255, 255, 255, 0.2)",
//                   },
//                   zIndex: 1,
//                 }}
//               >
//                 <ChevronRightIcon fontSize="large" />
//               </IconButton>
//             </>
//           )}

//           <Box
//             sx={{
//               width: "100%",
//               px: 8,
//               py: 2,
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//             }}
//           >
//             {viewerFiles.length > 0 && (
//               <img
//                 src={getFilePath(viewerFiles[selectedFileIndex])}
//                 alt={viewerFiles[selectedFileIndex]?.file_name || "Delivery file"}
//                 style={{
//                   maxWidth: "100%",
//                   maxHeight: "75vh",
//                   objectFit: "contain",
//                   borderRadius: "8px",
//                 }}
//               />
//             )}
//             <Typography
//               variant="body2"
//               sx={{ color: "rgba(255, 255, 255, 0.75)", mt: 2, textAlign: "center" }}
//             >
//               {viewerFiles.length > 0
//                 ? `${viewerFiles[selectedFileIndex]?.file_name || "File"} (${selectedFileIndex + 1} of ${viewerFiles.length})`
//                 : "No file available"}
//             </Typography>
//           </Box>
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

// export default OrderDetailsModal;

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Button,
  CircularProgress,
  DialogActions,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ReassignOrderButton from "./ReassignOrderButton";

import httpclient from "../../../../Utils";
import { useNotification } from "../../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
import OrderInformation from "./OrderInformation";
import OrderLinesTable from "./OrderLinesTable";
import OrderAuditTrialModal from "../../../../Components/modals/OrderAuditTrialModal";
import { getStatusColor } from "./orderUtils";

// ✅ Map status for display
const mapStatus = (status) => {
  const statusMap = {
    'inQueue': 'In Queue',
    'inProgress': 'In Progress',
    'inprogress': 'In Progress',
    'paused': 'Paused',
    'loaded': 'Loaded',
    'inTransit': 'In Transit',
    'dropToDepot': 'Drop To Depot',
    'drop to depot': 'Drop To Depot',
    'delivered': 'Delivered',
    'unloaded': 'Unloaded',
    'canceled': 'Canceled',
    'cancelled': 'Canceled',
  };
  
  const normalizedStatus = status?.toString().toLowerCase().trim() || '';
  return statusMap[normalizedStatus] || status || 'Unknown';
};

// Status History Table Component
const StatusHistoryTable = ({ history, getStatusChipStyles, formatDateTime, handleOpenFileViewer }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        border: "1px solid #D7DCE3",
        borderRadius: "10px",
        boxShadow: "0 1px 2px rgba(15, 23, 42, 0.08)",
        backgroundColor: "#FFFFFF",
        width: "100%",
        maxHeight: history?.length > 4 ? "260px" : "auto",
        overflowY: history?.length > 4 ? "auto" : "visible",
        overflowX: "auto",
        display: "block",
        '&::-webkit-scrollbar': {
          width: '6px',
          height: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#c1c1c1',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#a8a8a8',
        },
      }}
    >
      <Table
        size="small"
        sx={{
          minWidth: 650,
          "& .MuiTableHead-root .MuiTableCell-root": {
            backgroundColor: "#F8FAFC",
            borderBottom: "1px solid #D7DCE3",
            position: "sticky",
            top: 0,
            zIndex: 1,
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          },
          "& .MuiTableBody-root .MuiTableCell-root": {
            borderBottom: "1px solid #ECEFF3",
            paddingTop: "8px",
            paddingBottom: "8px",
          },
          "& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root": {
            borderBottom: "none",
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 100 }}>Status</TableCell>
            <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 140 }}>Date / Time</TableCell>
            <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 120 }}>Driver</TableCell>
            <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 140 }}>Remarks/Reason</TableCell>
            <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 120, textAlign: "center" }}>Signature</TableCell>
            <TableCell sx={{ fontWeight: 700, py: 1, minWidth: 120, textAlign: "center" }}>Other Files</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {history && history.length > 0 ? (
            history.map((item, index) => {
              const signatureFiles = item?.signature_files || [];
              const otherFiles = item?.other_files || [];
              const statusDisplay = item?.status;

              return (
                <TableRow key={`${item?.date_time || "status"}-${index}`}>
                  <TableCell sx={{ py: 0.75 }}>
                    <Chip
                      size="small"
                      label={statusDisplay || "-"}
                      sx={
                        item?.status_color
                          ? { bgcolor: item.status_color, color: "#fff" }
                          : getStatusChipStyles(item?.status)
                      }
                    />
                  </TableCell>
                  <TableCell sx={{ py: 0.75 }}>{formatDateTime(item?.date_time)}</TableCell>
                  <TableCell sx={{ py: 0.75 }}>{item?.driver || "-"}</TableCell>
                  <TableCell sx={{ py: 0.75 }}>{item?.remarks || item?.actionMessage || "-"}</TableCell>
                  <TableCell sx={{ py: 0.75, textAlign: "center" }}>
                    {signatureFiles.length > 0 ? (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleOpenFileViewer(signatureFiles, "Signature")}
                        sx={{
                          textTransform: "none",
                          fontSize: "12px",
                          borderColor: "#D1D5DB",
                          color: "#374151",
                          padding: '2px 10px',
                          '&:hover': {
                            borderColor: "#7152F3",
                            color: "#7152F3",
                            backgroundColor: "rgba(113, 82, 243, 0.04)",
                          },
                        }}
                      >
                        View
                      </Button>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell sx={{ py: 0.75, textAlign: "center" }}>
                    {otherFiles.length > 0 ? (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleOpenFileViewer(otherFiles, "Other Files")}
                        sx={{
                          textTransform: "none",
                          fontSize: "12px",
                          borderColor: "#D1D5DB",
                          color: "#374151",
                          padding: '2px 10px',
                          '&:hover': {
                            borderColor: "#7152F3",
                            color: "#7152F3",
                            backgroundColor: "rgba(113, 82, 243, 0.04)",
                          },
                        }}
                      >
                        {otherFiles.length > 1 ? `View (${otherFiles.length})` : "View"}
                      </Button>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center" sx={{ py: 2 }}>
                No delivery status history available.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

// ✅ UPDATED: Invoice Summary Table - With Horizontal and Vertical Scrolling
const InvoiceSummaryTable = ({ invoices, onInvoiceClick, selectedInvoice }) => {
  // Check if we need vertical scrolling (more than 4 invoices)
  const needsVerticalScroll = invoices.length > 4;
  // Check if we need horizontal scrolling (on small screens or when table is wide)
  const needsHorizontalScroll = invoices.length > 0;

  return (
    <TableContainer
      component={Paper}
      sx={{
        border: "1px solid #D7DCE3",
        borderRadius: "8px",
        boxShadow: "none",
        backgroundColor: "#FFFFFF",
        mb: 2,
        // ✅ Vertical scrolling - show 4 rows then scroll
        maxHeight: needsVerticalScroll ? "260px" : "auto",
        overflowY: needsVerticalScroll ? "auto" : "visible",
        // ✅ Horizontal scrolling
        overflowX: "auto",
        display: "block",
        // Custom scrollbar styling
        '&::-webkit-scrollbar': {
          width: '6px',
          height: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#c1c1c1',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#a8a8a8',
        },
      }}
    >
      <Table
        size="small"
        sx={{
          // ✅ Ensure minimum width for horizontal scrolling
          minWidth: 650,
          "& .MuiTableHead-root .MuiTableCell-root": {
            backgroundColor: "#F9FAFB",
            borderBottom: "1px solid #D7DCE3",
            color: "#6B7280",
            fontWeight: 700,
            fontSize: "12px",
            py: 1.5,
            // ✅ Sticky header for vertical scrolling
            position: "sticky",
            top: 0,
            zIndex: 1,
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          },
          "& .MuiTableBody-root .MuiTableCell-root": {
            borderBottom: "1px solid #ECEFF3",
            color: "#111827",
            fontSize: "13px",
            py: 1.25,
          },
          "& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root": {
            borderBottom: "none",
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ minWidth: 120, fontWeight: 700 }}>Invoice No</TableCell>
            <TableCell sx={{ minWidth: 120, fontWeight: 700 }}>Driver</TableCell>
            <TableCell sx={{ minWidth: 120, fontWeight: 700 }}>Invoice Date</TableCell>
            <TableCell sx={{ minWidth: 120, fontWeight: 700 }}>Delivery Date</TableCell>
            <TableCell sx={{ minWidth: 120, fontWeight: 700 }}>Order Date</TableCell>
            <TableCell sx={{ minWidth: 120, fontWeight: 700 }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoices.map((invoice, index) => (
            <TableRow 
              key={invoice.invoice_number || index}
              hover
              onClick={() => onInvoiceClick(invoice.invoice_number)}
              sx={{ 
                cursor: 'pointer',
                backgroundColor: selectedInvoice === invoice.invoice_number ? '#F3F4F6' : 'transparent',
                '&:hover': {
                  backgroundColor: '#F9FAFB',
                }
              }}
            >
              <TableCell sx={{ fontWeight: 500 }}>
                {invoice.invoice_number}
              </TableCell>
              <TableCell>
                {invoice.assigned_driver || "-"}
              </TableCell>
              <TableCell>
                {invoice.invoice_date || "-"}
              </TableCell>
              <TableCell>
                {invoice.delivery_date || "-"}
              </TableCell>
              <TableCell>
                {invoice.order_date || "-"}
              </TableCell>
              <TableCell>
                <Chip
                  size="small"
                  label={mapStatus(invoice.delivery_status) || "Unknown"}
                  sx={
                    invoice.delivery_status_color
                      ? {
                          backgroundColor: invoice.delivery_status_color,
                          color: "#fff",
                          fontWeight: 600,
                          height: 24,
                          fontSize: "11px",
                        }
                      : {
                          backgroundColor: getStatusColor(invoice.delivery_status).bgcolor,
                          color: getStatusColor(invoice.delivery_status).color,
                          fontWeight: 600,
                          height: 24,
                          fontSize: "11px",
                        }
                  }
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

// Main OrderDetailsModal Component
const OrderDetailsModal = ({ 
  open, 
  onClose, 
  invoiceNumbers,
  jobId,
  allDrivers = [], 
  onRefresh 
}) => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [auditTrailOpen, setAuditTrailOpen] = useState(false);
  const [fileViewerOpen, setFileViewerOpen] = useState(false);
  const [viewerFiles, setViewerFiles] = useState([]);
  const [viewerTitle, setViewerTitle] = useState("");
  const [selectedFileIndex, setSelectedFileIndex] = useState(0);
  const [expandedInvoice, setExpandedInvoice] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [suspendDialogOpen, setSuspendDialogOpen] = useState(false);
  const [suspending, setSuspending] = useState(false);
  const [suspendReason, setSuspendReason] = useState("");
  const [unsuspendDialogOpen, setUnsuspendDialogOpen] = useState(false);
  const [unsuspending, setUnsuspending] = useState(false);
  const [unloadDialogOpen, setUnloadDialogOpen] = useState(false);
  const [unloading, setUnloading] = useState(false);

  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: refresh } = useTokenRefresh();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("🔍 OrderDetailsModal useEffect");
    console.log("📋 open:", open);
    console.log("📋 invoiceNumbers:", invoiceNumbers);
    console.log("📋 jobId:", jobId);
    
    if (open && invoiceNumbers) {
      fetchInvoiceDetails();
    }
  }, [open, invoiceNumbers]);

  const fetchInvoiceDetails = async () => {
    setLoading(true);
    try {
      let invoiceParam = invoiceNumbers;
      if (Array.isArray(invoiceNumbers)) {
        invoiceParam = invoiceNumbers.join(',');
      }
      
      const apiUrl = `delivery/orders/invoice/job-details?invoice_numbers=${invoiceParam}`;
      console.log("📡 Calling API:", apiUrl);
      
      const { data } = await httpclient.get(apiUrl);
      console.log("✅ API Response:", data);

      if (data.status === 200) {
        setInvoices(data.data);
        // Set first invoice as expanded by default
        if (data.data.length > 0) {
          setExpandedInvoice(data.data[0].invoice_number);
        }
      } else {
        showNotification("error", data.message || "Failed to fetch invoice details");
      }
    } catch (error) {
      console.error("❌ API Error:", error);
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleAuditTrailOpen = () => {
    setAuditTrailOpen(true);
  };

  const handleAuditTrailClose = () => {
    setAuditTrailOpen(false);
  };

  const handleReassignSuccess = () => {
    fetchInvoiceDetails();
    if (onRefresh && typeof onRefresh === 'function') {
      onRefresh();
    }
  };

  const handleSuspendOpen = () => {
    setSuspendReason("");
    setSuspendDialogOpen(true);
  };

  const handleSuspendClose = () => {
    setSuspendDialogOpen(false);
    setSuspendReason("");
  };

  const handleSuspendConfirm = async () => {
    if (!currentInvoice?.job_id) return;

    try {
      setSuspending(true);
      const { data } = await httpclient.post(
        `delivery/orders/invoice/suspended/${currentInvoice.job_id}`,
        { suspended_reason: suspendReason }
      );

      if (data.status === 200) {
        showNotification("success", data.message);
        handleSuspendClose();
        fetchInvoiceDetails();
        if (onRefresh && typeof onRefresh === "function") {
          onRefresh();
        }
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setSuspending(false);
    }
  };

  const handleUnsuspendOpen = () => {
    setUnsuspendDialogOpen(true);
  };

  const handleUnsuspendClose = () => {
    setUnsuspendDialogOpen(false);
  };

  const handleUnsuspendConfirm = async () => {
    if (!currentInvoice?.driver_id || !currentInvoice?.invoice_number) return;

    const formData = new FormData();
    formData.append("invoices[]", currentInvoice.invoice_number);

    try {
      setUnsuspending(true);
      const { data } = await httpclient.post(
        `delivery/drivers/invoice/${currentInvoice.driver_id}/release`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (data.status === 200) {
        showNotification("success", data.message);
        handleUnsuspendClose();
        fetchInvoiceDetails();
        if (onRefresh && typeof onRefresh === "function") {
          onRefresh();
        }
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setUnsuspending(false);
    }
  };

  const handleUnloadOpen = () => {
    setUnloadDialogOpen(true);
  };

  const handleUnloadClose = () => {
    setUnloadDialogOpen(false);
  };

  const handleUnloadConfirm = async () => {
    if (!currentInvoice?.job_id) return;

    try {
      setUnloading(true);
      const { data } = await httpclient.post(
        `delivery/orders/invoice/unload/${currentInvoice.job_id}`
      );

      if (data.status === 200) {
        showNotification("success", data.message);
        handleUnloadClose();
        fetchInvoiceDetails();
        if (onRefresh && typeof onRefresh === "function") {
          onRefresh();
        }
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setUnloading(false);
    }
  };

  const formatDateTime = (value) => {
    if (!value) return "-";
    const parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) {
      return value;
    }
    return parsedDate.toLocaleString("en-AU", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const getFilePath = (file) => {
    if (typeof file === "string") return file;
    return file?.file_path || "";
  };

  const handleOpenFileViewer = (files, title) => {
    const validFiles = (files || []).filter((file) => Boolean(getFilePath(file)));
    if (validFiles.length === 0) {
      return;
    }
    setViewerFiles(validFiles);
    setViewerTitle(title);
    setSelectedFileIndex(0);
    setFileViewerOpen(true);
  };

  const handleCloseFileViewer = () => {
    setFileViewerOpen(false);
    setViewerFiles([]);
    setViewerTitle("");
    setSelectedFileIndex(0);
  };

  const handlePrevFile = () => {
    setSelectedFileIndex((prev) =>
      prev === 0 ? viewerFiles.length - 1 : prev - 1
    );
  };

  const handleNextFile = () => {
    setSelectedFileIndex((prev) =>
      prev === viewerFiles.length - 1 ? 0 : prev + 1
    );
  };

  // ✅ Use imported getStatusColor from orderUtils
  const getStatusChipStyles = (statusValue) => {
    const colors = getStatusColor(statusValue);
    return {
      backgroundColor: colors.bgcolor,
      color: colors.color,
      border: "none",
      fontWeight: 600,
      height: 24,
      "& .MuiChip-label": {
        px: 1,
      },
    };
  };

  const handleAccordionChange = (invoiceNumber) => (event, isExpanded) => {
    setExpandedInvoice(isExpanded ? invoiceNumber : null);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    if (invoices[newValue]) {
      setExpandedInvoice(invoices[newValue].invoice_number);
    }
  };

  const getCurrentInvoice = () => {
    if (invoices.length === 0) return null;
    return invoices[selectedTab] || null;
  };

  const currentInvoice = getCurrentInvoice();

  if (!invoiceNumbers) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6">Job Details</Typography>
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 4 }}>
            No invoice numbers provided. Please check the parent component.
          </Typography>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "8px",
            height: "90vh",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Job Details
            </Typography>
            {!loading && invoices.length > 0 && (
              <Chip
                size="small"
                label={`${invoices.length} Invoice${invoices.length > 1 ? 's' : ''}`}
                sx={{
                  backgroundColor: "#E5E7EB",
                  color: "#374151",
                  fontWeight: 600,
                  height: 24,
                }}
              />
            )}
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            display: "flex",
            flexDirection: "column",
            px: 2,
            py: 1.5,
            gap: 2,
            overflow: "auto",
          }}
        >
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 300,
              }}
            >
              <CircularProgress />
            </Box>
          ) : invoices.length > 0 ? (
            <>
              {/* 1. Delivery Status History */}
              <Box>
                {/* <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, mb: 1, color: "#383E49" }}
                >
                  Delivery Status History
                </Typography> */}

                {currentInvoice && (
                  <Accordion
                    expanded={expandedInvoice === currentInvoice.invoice_number}
                    onChange={handleAccordionChange(currentInvoice.invoice_number)}
                    sx={{
                      border: "1px solid #E5E7EB",
                      borderRadius: "8px !important",
                      boxShadow: "none",
                      mb: 2,
                      '&:before': {
                        display: 'none',
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        backgroundColor: "#FAFAFA",
                        borderRadius: "8px",
                        '&.Mui-expanded': {
                          borderRadius: "8px 8px 0 0",
                        },
                      }}
                    >
                      <Typography sx={{ fontWeight: 600 }}>
                        Status History
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 2 }}>
                      <StatusHistoryTable
                        history={currentInvoice.order_delivery_status_history}
                        getStatusChipStyles={getStatusChipStyles}
                        formatDateTime={formatDateTime}
                        handleOpenFileViewer={handleOpenFileViewer}
                      />
                    </AccordionDetails>
                  </Accordion>
                )}
              </Box>

              {/* 2. Invoice Summary - ✅ With Horizontal and Vertical Scrolling */}
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, mb: 1.5, color: "#383E49" }}
                >
                  Invoice Summary
                </Typography>
                <InvoiceSummaryTable 
                  invoices={invoices} 
                  onInvoiceClick={(invoiceNumber) => {
                    const index = invoices.findIndex(inv => inv.invoice_number === invoiceNumber);
                    if (index !== -1) {
                      setSelectedTab(index);
                      if (invoices[index]) {
                        setExpandedInvoice(invoices[index].invoice_number);
                      }
                    }
                  }}
                  selectedInvoice={invoices[selectedTab]?.invoice_number}
                />
              </Box>

              {/* 3. Order Information (includes Customer Details) */}
              {currentInvoice && (
                <Box>
                  <OrderInformation orderDetails={currentInvoice} />
                </Box>
              )}

              {/* 4. Order Lines Table - Using the imported component */}
              {currentInvoice && (
                <Box sx={{ mb: 2 }}>
                  <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                      borderBottom: 1,
                      borderColor: 'divider',
                      mb: 2,
                      '& .MuiTab-root': {
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '14px',
                        minHeight: 40,
                      },
                      '& .Mui-selected': {
                        color: '#7152F3',
                      },
                      '& .MuiTabs-indicator': {
                        backgroundColor: '#7152F3',
                      },
                    }}
                  >
                    {invoices.map((invoice, index) => (
                      <Tab
                        key={invoice.invoice_number || index}
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <span>{invoice.invoice_number}</span>
                            <Chip
                              size="small"
                              label={mapStatus(invoice.delivery_status) || "Unknown"}
                              sx={
                                invoice.delivery_status_color
                                  ? {
                                      backgroundColor: invoice.delivery_status_color,
                                      color: "#fff",
                                      fontWeight: 600,
                                      height: 20,
                                      fontSize: "10px",
                                    }
                                  : {
                                      backgroundColor: getStatusColor(invoice.delivery_status).bgcolor,
                                      color: getStatusColor(invoice.delivery_status).color,
                                      fontWeight: 600,
                                      height: 20,
                                      fontSize: "10px",
                                    }
                              }
                            />
                          </Box>
                        }
                      />
                    ))}
                  </Tabs>

                  {/* <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 1.5, color: "#383E49" }}
                  >
                    Order Lines
                  </Typography> */}
                  <OrderLinesTable jobId={currentInvoice.job_id} />
                </Box>
              )}
            </>
          ) : (
            <Typography variant="body2" color="text.secondary" align="center">
              No invoice details available
            </Typography>
          )}
        </DialogContent>

        {!loading && invoices.length > 0 && (
          <DialogActions
            sx={{
              px: 3,
              pb: 2,
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            {currentInvoice?.invoice_reassign_button_enabled === 1 && (
              <ReassignOrderButton
                jobId={currentInvoice?.job_id}
                currentDriverName={currentInvoice?.assigned_driver}
                currentDriverId={currentInvoice?.driver_id}
                allDrivers={allDrivers}
                onSuccess={handleReassignSuccess}
                buttonText="Reassign Invoice"
                variant="outlined"
                size="medium"
              />
            )}

            {currentInvoice?.release_suspend_order === 1 ? (
              <Button
                variant="outlined"
                onClick={handleUnsuspendOpen}
                sx={{
                  borderColor: "#C2185B",
                  color: "#C2185B",
                  fontWeight: 600,
                  px: 3,
                  py: 1,
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "14px",
                  "&:hover": {
                    borderColor: "#a01650",
                    backgroundColor: "rgba(194, 24, 91, 0.08)",
                  },
                }}
              >
                Unsuspend
              </Button>
            ) : (
              currentInvoice?.suspend_button_enabled === 1 && (
                <Button
                  variant="outlined"
                  onClick={handleSuspendOpen}
                  sx={{
                    borderColor: "#C2185B",
                    color: "#C2185B",
                    fontWeight: 600,
                    px: 3,
                    py: 1,
                    borderRadius: "8px",
                    textTransform: "none",
                    fontSize: "14px",
                    "&:hover": {
                      borderColor: "#a01650",
                      backgroundColor: "rgba(194, 24, 91, 0.08)",
                    },
                  }}
                >
                  Suspend
                </Button>
              )
            )}

            {currentInvoice?.unload_button_enabled === 1 && (
              <Button
                variant="outlined"
                onClick={handleUnloadOpen}
                sx={{
                  borderColor: "#EF6C00",
                  color: "#EF6C00",
                  fontWeight: 600,
                  px: 3,
                  py: 1,
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "14px",
                  "&:hover": {
                    borderColor: "#c25a00",
                    backgroundColor: "rgba(239, 108, 0, 0.08)",
                  },
                }}
              >
                Unload
              </Button>
            )}

            <Button
              variant="outlined"
              onClick={handleAuditTrailOpen}
              sx={{
                borderColor: "#7152F3",
                color: "#7152F3",
                fontWeight: 600,
                px: 3,
                py: 1,
                borderRadius: "8px",
                textTransform: "none",
                fontSize: "14px",
                "&:hover": {
                  borderColor: "#5c34fa",
                  backgroundColor: "rgba(113, 82, 243, 0.08)",
                },
              }}
            >
              View Audit Trail
            </Button>
          </DialogActions>
        )}
      </Dialog>

      {/* Audit Trail Modal */}
      {auditTrailOpen && (
        <OrderAuditTrialModal
          open={auditTrailOpen}
          handleClose={handleAuditTrailClose}
          jobId={currentInvoice?.job_id}
        />
      )}

      {/* Suspend Confirmation Dialog */}
      <Dialog
        open={suspendDialogOpen}
        onClose={handleSuspendClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Suspend Order</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Do you want to suspend the job?
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={3}
            label="Reason (optional)"
            placeholder="Enter reason for suspending"
            value={suspendReason}
            onChange={(e) => setSuspendReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            onClick={handleSuspendClose}
            disabled={suspending}
          >
            No
          </Button>
          <Button
            variant="contained"
            onClick={handleSuspendConfirm}
            sx={{
              backgroundColor: "#1a237e",
              "&:hover": { backgroundColor: "#101858" },
            }}
            disabled={suspending}
          >
            {suspending ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Yes"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Unsuspend Confirmation Dialog */}
      <Dialog
        open={unsuspendDialogOpen}
        onClose={handleUnsuspendClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Unsuspend Order</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Do you want to unsuspend this job?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            onClick={handleUnsuspendClose}
            disabled={unsuspending}
          >
            No
          </Button>
          <Button
            variant="contained"
            onClick={handleUnsuspendConfirm}
            sx={{
              backgroundColor: "#1a237e",
              "&:hover": { backgroundColor: "#101858" },
            }}
            disabled={unsuspending}
          >
            {unsuspending ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Yes"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Unload Confirmation Dialog */}
      <Dialog
        open={unloadDialogOpen}
        onClose={handleUnloadClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Unload Order</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 1 }}>
            Do you want to unload the job?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Job ID: {currentInvoice?.job_id}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            onClick={handleUnloadClose}
            disabled={unloading}
          >
            No
          </Button>
          <Button
            variant="contained"
            onClick={handleUnloadConfirm}
            sx={{
              backgroundColor: "#1a237e",
              "&:hover": { backgroundColor: "#101858" },
            }}
            disabled={unloading}
          >
            {unloading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Yes"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* File Viewer Dialog */}
      <Dialog
        open={fileViewerOpen}
        onClose={handleCloseFileViewer}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: "rgba(0, 0, 0, 0.95)",
            borderRadius: "12px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          <Typography variant="subtitle1" sx={{ color: "#fff", fontWeight: 600 }}>
            {viewerTitle}
          </Typography>
          <IconButton onClick={handleCloseFileViewer} size="small" sx={{ color: "#fff" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            p: 0,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "420px",
          }}
        >
          {viewerFiles.length > 1 && (
            <>
              <IconButton
                onClick={handlePrevFile}
                sx={{
                  position: "absolute",
                  left: 16,
                  color: "white",
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                  "&:hover": {
                    bgcolor: "rgba(255, 255, 255, 0.2)",
                  },
                  zIndex: 1,
                }}
              >
                <ChevronLeftIcon fontSize="large" />
              </IconButton>

              <IconButton
                onClick={handleNextFile}
                sx={{
                  position: "absolute",
                  right: 16,
                  color: "white",
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                  "&:hover": {
                    bgcolor: "rgba(255, 255, 255, 0.2)",
                  },
                  zIndex: 1,
                }}
              >
                <ChevronRightIcon fontSize="large" />
              </IconButton>
            </>
          )}

          <Box
            sx={{
              width: "100%",
              px: 8,
              py: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {viewerFiles.length > 0 && (
              <img
                src={getFilePath(viewerFiles[selectedFileIndex])}
                alt={viewerFiles[selectedFileIndex]?.file_name || "Delivery file"}
                style={{
                  maxWidth: "100%",
                  maxHeight: "75vh",
                  objectFit: "contain",
                  borderRadius: "8px",
                }}
              />
            )}
            <Typography
              variant="body2"
              sx={{ color: "rgba(255, 255, 255, 0.75)", mt: 2, textAlign: "center" }}
            >
              {viewerFiles.length > 0
                ? `${viewerFiles[selectedFileIndex]?.file_name || "File"} (${selectedFileIndex + 1} of ${viewerFiles.length})`
                : "No file available"}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OrderDetailsModal;